import Aegis from '@tencent/aegis-web-sdk';

let aegis: Aegis;

export default () => {
  // process.env.VUE_APP_BUILD_FOR === 'production' 判断是生产环境
  if (!aegis && process.env.VUE_APP_BUILD_FOR === 'production') {
    aegis = new Aegis({
      id: 'mAynmesICeCaGZsLyf',
      reportApiSpeed: false,
      reportAssetSpeed: true,
      spa: true,
      ext3: 'native version not set',
    });
  }
  return aegis;
};
